module.exports = __webpack_public_path__ + "img/zq4.0eae56fa.png";